import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '@/components/SectionHeading';
import { useInView } from '@/lib/hooks';
import { TESTIMONIALS } from '@/constants/testIds';

const QUOTES = [
  { quote: 'We were embarrassed by our old website. SiteHive rebuilt it in 4 days and we got 3 new catering inquiries the first week.', name: 'Ritu S.', biz: 'The Brew Spot', initials: 'RS' },
  { quote: "I didn’t think a small studio could afford something this professional. SiteHive proved me wrong.", name: 'Harpreet K.', biz: 'Luxe Threads', initials: 'HK' },
  { quote: 'Honest, fast, and the result actually looks like my brand. Highly recommend.', name: 'Aryan M.', biz: 'Aryan Interiors', initials: 'AM' },
];

function QuoteIcon() {
  return (
    <svg width="30" height="22" viewBox="0 0 34 26" className="text-[color:var(--sh-amber)]" aria-hidden>
      <path d="M0 26V14C0 6.5 4.5 1.5 12 0L13 4C8.5 5 6 8 6 13H12V26H0ZM21 26V14C21 6.5 25.5 1.5 33 0L34 4C29.5 5 27 8 27 13H33V26H21Z" fill="currentColor" />
    </svg>
  );
}

export default function Testimonials() {
  const [ref, inView] = useInView({ threshold: 0.15, once: true });
  return (
    <section className="section" data-testid={TESTIMONIALS.block}>
      <div className="container-pro">
        <SectionHeading
          eyebrow="WHAT CLIENTS SAY"
          title="Businesses that took the leap."
        />
        <div
          ref={ref}
          className="flex md:grid md:grid-cols-3 gap-5 overflow-x-auto md:overflow-visible snap-x-h pb-2 -mx-4 px-4 md:mx-0 md:px-0"
        >
          {QUOTES.map((q, i) => (
            <motion.figure
              key={q.name}
              initial={{ opacity: 0, y: 14 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.1 + i * 0.1 }}
              className="card-light p-7 min-w-[86%] md:min-w-0 snap-start"
            >
              <QuoteIcon />
              <blockquote className="mt-4 font-display italic text-[1.05rem] leading-relaxed text-[color:var(--sh-ink-soft)]">
                “{q.quote}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 pt-5 border-t border-[color:var(--sh-line-2)]">
                <span className="w-9 h-9 rounded-full inline-flex items-center justify-center font-accent font-semibold text-[12px] text-white"
                  style={{ background: '#0F1A33' }}>{q.initials}</span>
                <div>
                  <div className="font-medium text-[14px] text-[color:var(--sh-ink)]">{q.name}</div>
                  <div className="text-[11px] uppercase tracking-widest text-[color:var(--sh-muted)] font-accent">{q.biz}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
